import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import logo from "../../img/ICONTEC-LOGO-ORIGINAL-INV.png";

const ConflictoInteres = () => {
  let { id } = useParams();
  let { asignacion } = useParams();

  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const [respuesta, setRespuesta] = useState(null);

  const [institucionId, setInstitucionId] = useState(null);
  const [razonSocial, setRazonSocial] = useState("");
  const [Nit, setNit] = useState("");

  useEffect(() => {
    const obtenerDatos = async () => {
      try {
        const resSolicitud = await axios.get(
          `https://suadesarrollo.azurewebsites.net/api/ObtenerSolicitudesPorId?Id=${id}`,
        );

        const idInst = resSolicitud.data?.[0]?.institucionId;
        setInstitucionId(idInst);

        const nit = resSolicitud.data?.[0]?.nit;
        setNit(nit);

        if (idInst) {
          const resInst = await axios.get(
            `https://suadesarrollo.azurewebsites.net/Api/ObtenerInstitucionesPorId?Id=${idInst}`,
          );

          setRazonSocial(resInst.data?.[0]?.razon_Social);
          setNit(resInst.data?.[0]?.nit);
        }
      } catch (error) {
        console.error("Error obteniendo datos", error);
      }
    };

    if (id) obtenerDatos();
  }, [id]);

  const handleChange = (e) => {
    setValue(e.target.value);
    setRespuesta(null);
  };

  const enviarRespuesta = async () => {
    if (value === null) {
      alert("Por favor selecciona una opción");
      return;
    }

    setLoading(true);

    try {
      await axios.patch(
        `https://suadesarrollo.azurewebsites.net/api/JuntaDirectiva/ActualizarConflictoInteres/${asignacion}`,
        {
          ConflictoInteres: value === "true",
        },
      );

      setRespuesta(value);

      if (value === "false") {
        setTimeout(() => {
          window.location.href = "/";
        }, 3000);
      }
    } catch (error) {
      alert("Error al enviar la información");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="container d-flex align-items-center justify-content-center"
      style={{ height: "73vh" }}
    >
      <div className="card shadow-lg" style={{ width: "600px" }}>
        <div className="card-header bg-primary text-white text-center">
          <h6 className="m-0">
            SISTEMA ÚNICO DE ACREDITACIÓN <br></br>
            <img src={logo} width={"120px"} alt="logo" />
          </h6>
        </div>

        <div className="card-body">
          <p className="text-gray-800">
            <strong>Institución:</strong> {razonSocial || "Cargando..."}
          </p>

          <p className="text-gray-800">
            <strong>NIT:</strong> {Nit || "Cargando..."}
          </p>

          <p className="text-gray-800">
            Por favor indique si presenta algún conflicto de interés para esta
            asignación:
          </p>

          <div className="form-group mt-3">
            <div className="custom-control custom-radio">
              <input
                type="radio"
                id="si"
                name="conflicto"
                className="custom-control-input"
                value={true}
                onChange={handleChange}
              />
              <label className="custom-control-label" htmlFor="si">
                Sí
              </label>
            </div>

            <div className="custom-control custom-radio mt-2">
              <input
                type="radio"
                id="no"
                name="conflicto"
                className="custom-control-input"
                value={false}
                onChange={handleChange}
              />
              <label className="custom-control-label" htmlFor="no">
                No
              </label>
            </div>
          </div>

          <button
            className="btn btn-primary btn-block mt-4"
            onClick={enviarRespuesta}
            disabled={loading}
          >
            {loading ? "Enviando..." : "Enviar"}
          </button>

          {respuesta === "true" && (
            <div className="alert alert-danger mt-4" role="alert">
              Se ha notificado al administrador del sistema sobre el conflicto
              de interés.
            </div>
          )}

          {respuesta === "false" && (
            <div className="alert alert-success mt-4" role="alert">
              No presenta conflicto de interés. Ya puede acceder a la
              plataforma. Será redirigido...
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConflictoInteres;
